import { MapPin, Globe2, Sparkles } from 'lucide-react';
import { MarketingHeroPill } from '@/components/marketing/v2/MarketingHeroPill';

export default function AboutHeroV2() {
  return (
    <section className="bg-paper pb-16 pt-16 md:pb-20 md:pt-20">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <MarketingHeroPill>À propos · La caisse pensée pour l'Afrique</MarketingHeroPill>

        <h1 className="mt-7 font-marketing-display text-[clamp(48px,7.2vw,108px)] font-bold leading-[0.9] tracking-[-0.045em] text-charcoal-800">
          Construits
          <br />
          <span className="underline-lime">à Yaoundé.</span>
          <br />
          <span className="text-charcoal-400">Pour toute l'Afrique.</span>
        </h1>

        <p className="mt-8 max-w-3xl font-marketing-body text-lg leading-[1.55] text-charcoal-600 md:text-xl">
          Velko n'est pas un logiciel qu'on adapte depuis la Silicon Valley. C'est un outil qu'on a
          bâti en vivant les coupures de courant, les pannes d'Orange Money, les cahiers qui
          s'effacent. Pour que ta caisse marche comme toi, pas comme un rapport Gartner.
        </p>

        <div className="mt-10 flex flex-wrap items-center gap-4 border-t-2 border-dashed border-charcoal-200 pt-6 font-marketing-mono text-[11.5px] font-medium uppercase tracking-[0.12em] text-charcoal-600">
          <span className="inline-flex items-center gap-2">
            <MapPin className="h-3.5 w-3.5" strokeWidth={2.4} />
            Yaoundé · Afrique francophone
          </span>
          <span className="h-3 w-px bg-charcoal-300" />
          <span className="inline-flex items-center gap-2">
            <Globe2 className="h-3.5 w-3.5" strokeWidth={2.4} />
            Web · Desktop · Mobile
          </span>
          <span className="h-3 w-px bg-charcoal-300" />
          <span className="inline-flex items-center gap-2">
            <Sparkles className="h-3.5 w-3.5" strokeWidth={2.4} />
            Disponible dès aujourd'hui
          </span>
        </div>
      </div>
    </section>
  );
}
